import { API_URL } from '../config';
import React, { useState, useEffect } from 'react'; // 1. เพิ่ม useState และ useEffect
import { useNavigate, useParams } from 'react-router-dom';
import './Member.css';

const TAG_COLORS = {
  'Open Data':            { background: '#7BAE8E', color: 'white' },
  'Public Procurement':   { background: '#D97757', color: 'white' },
  'WhistleBlower':        { background: '#D4A96A', color: 'white' },
  'Business integrity':   { background: '#7A9BB5', color: 'white' },
};
const getTagStyle = (label) => TAG_COLORS[label] || { background: '#cab8d9', color: '#1a1a1a' };

const Member = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // รับ id จาก URL เช่น /member/1
  
  // 2. สร้าง State สำหรับเก็บข้อมูลสมาชิกที่ดึงมาได้
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expertiseDescMap, setExpertiseDescMap] = useState({});

  useEffect(() => {
    fetch(`${API_URL}/api/expertise`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        const map = {};
        data.forEach(e => { map[e.label] = e.description || ''; });
        setExpertiseDescMap(map);
      })
      .catch(() => {});
  }, []);

  // 3. ดึงข้อมูลจาก API เมื่อ Component โหลด
  useEffect(() => {
    fetch(`${API_URL}/api/people/${id}`)
      .then(response => {
        if (!response.ok) throw new Error('Member not found');
        return response.json();
      })
      .then(data => {
        setMember(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false);
      });
  }, [id]); // ทำงานใหม่ทุกครั้งที่ id เปลี่ยน

  const handleBack = () => {
    navigate('/');
  };

  // 4. ถ้ากำลังโหลด หรือไม่พบข้อมูล ให้แสดงข้อความแจ้ง
  if (loading) return <div className="loading">Loading...</div>;
  if (!member) return <div className="error">Member not found!</div>;

  return (
    <div className="member-page">
      {/* Header */}
      <div className="member-header">
        <button className="back-button" onClick={handleBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="member-header-title">Member</h1>
      </div>

      <div className="member-content">
        <div className="profile-avatar">
          {member.avatar ? (
            <img src={member.avatar.startsWith('http') ? member.avatar : `${API_URL}${member.avatar}`} alt="Profile" className="avatar-preview" />
          ) : (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="7" r="4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>

        <div className="member-sections-grid">
        {/* Personal Detail - นำข้อมูลจาก member มาใช้ */}
        <section className="detail-section">
          <h2 className="section-title">Personal Detail</h2>
          
          <div className="form-group">
            <label className="form-label">Name - Surname (EN)</label>
            <input 
              type="text" 
              className="form-input" 
              value={member.name} // เปลี่ยนจาก placeholder เป็น value
              readOnly 
            />
          </div>

          <div className="form-group">
            <label className="form-label">ชื่อ - นามสกุล (ไทย)</label>
            <input 
              type="text" 
              className="form-input" 
              value={member.name_th}
              readOnly 
            />
          </div>

          <div className="form-group">
            <label className="form-label">National / สัญชาติ</label>
            <input 
              type="text" 
              className="form-input" 
              value={member.national || ''}
              readOnly 
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email / อีเมล</label>
            <input
              type="email"
              className="form-input"
              value={member.email}
              readOnly
            />
          </div>

          <div className="form-group">
            <label className="form-label">Phone / เบอร์โทรศัพท์</label>
            <input
              type="tel"
              className="form-input"
              value={member.phone || ''}
              readOnly
            />
          </div>

          <div className="form-group">
            <label className="form-label">Expertise / ความเชี่ยวชาญ</label>
            <div className="tag-container">
              {member.tags.map((tag, index) => {
                const desc = tag.description || expertiseDescMap[tag.label] || '';
                return (
                  <div key={index} className="tag-pill-wrap">
                    <span className={`tag ${index === 0 ? 'tag-primary' : 'tag-secondary'}`} style={getTagStyle(tag.label)}>
                      {tag.label}
                    </span>
                    {desc && <span className="tag-pill-tooltip">{desc}</span>}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Other Network / เครือข่ายอื่น ๆ</label>
            <input
              type="text"
              className="form-input"
              value={member.network || ''}
              readOnly
            />
          </div>
        </section>

        {/* Organization Detail */}
        <section className="detail-section">
          <h2 className="section-title">Organization Detail</h2>
          <div className="form-group">
            <label className="form-label">Organization Name (EN)</label>
            <input
              type="text"
              className="form-input"
              value={member.project || ''}
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">ชื่อองค์กร (ไทย)</label>
            <input
              type="text"
              className="form-input"
              value={member.project_th || ''}
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">Position (EN)</label>
            <input
              type="text"
              className="form-input"
              value={member.position || ''}
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">ตำแหน่ง (ไทย)</label>
            <input
              type="text"
              className="form-input"
              value={member.position_th || ''}
              readOnly
            />
          </div>
          <div className="form-group">
            <label className="form-label">Country / ประเทศ</label>
            <input
              type="text"
              className="form-input"
              value={member.country || ''}
              readOnly
            />
          </div>
        </section>
        </div>{/* end member-sections-grid */}

        {/* Note */}
        {member.note && (
          <div className="note-section">
            <h2 className="note-title">Note</h2>
            <textarea
              className="form-input note-textarea"
              value={member.note}
              readOnly
            />
          </div>
        )}

        {/* Name Card */}
        <div className="name-card-preview-section">
          <h2 className="note-title">Name Card</h2>
          <div className="namecard-display">
            <span className="namecard-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="2" fill="#1a1a1a"/>
                <path d="M3 17l5-5 4 4 3-3 6 6" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
              </svg>
            </span>
            {member.nameCard ? (
              <a
                className="namecard-link"
                href={member.nameCard.startsWith('http') ? member.nameCard : `${API_URL}${member.nameCard}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {member.nameCard.split('/').pop()}
              </a>
            ) : (
              <span className="namecard-empty">ไม่มีไฟล์</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Member;